import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" fill="none" viewBox="0 0 22 27">
      <path
        fill="#fff"
        d="M15.052 8.515l.09 6.507c-.02 1.146-1.545 1.963-2.774 1.628l-9.263-3.49a.997.997 0 00-.891.028.865.865 0 00-.32.299.755.755 0 00-.117.4l.037 11.1v.457l-1.636.586L0 12.904c-.012-.93 1.276-2.008 2.264-1.734l9.7 3.66a1.013 1.013 0 00.88-.096.85.85 0 00.292-.315.752.752 0 00.087-.403l-.039-2.967c-.03-2.284.375-2.747-1.065-3.53L1.525 3.412 3.8 2.588l10.343 3.988c.558.217.925 1.401.91 1.939z"
      ></path>
      <path
        fill="#fff"
        d="M8.562 16.728l.09 6.64-1.896.638-.108-7.979 1.914.7zM21.743 4.904a1.454 1.454 0 00-.27-.678 1.663 1.663 0 00-.583-.496l-.82-.435-1.532-.567-1.914-.708-1.532-.562-1.917-.707-1.66-.612V0L9.072.832l2.468.913 1.66.612 1.914.707 1.532.567 1.912.704c.037.01.072.024.105.042.127.07.28.095.409.174.153.08.294.176.42.287.225.19.38.437.444.708a.428.428 0 01.039.173l.12 8.904 1.275-.397a.922.922 0 00.456-.301.774.774 0 00.175-.483l-.257-8.538zM11.637 9.1l.021 1.511L8.594 9.48l-1.021-.31.884-.352 1.136-.47.269.098 1.775.656zM5.371 15.483l.12 8.959-1.895.638-.14-10.298 1.915.701z"
      ></path>
      <path
        fill="#fff"
        d="M16.651 15.235l-.083-7.763-.089-.546a1.523 1.523 0 00-.644-.763l-.708-.44-1.917-.694-1.66-.614-3.06-1.14-1.914-.707-1.257-.463 1.241-.423 1.098-.375.805.297 3.063 1.13 1.66.614 1.915.708 1.533.567.772.43c.316.175.578.42.76.71.184.29.282.618.286.951l.092 8.179c0 .06-.02.12-.057.171a.34.34 0 01-.153.115l-1.932.742M11.672 11.76l.023 1.583-3.065-1.12-1.916-.701-1.403-.514-1.474-.539 1.46-.49.784-.264.612.223 1.916.701 3.063 1.12z"
      ></path>
    </svg>
  )
}

export default Icon
